import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { StoreProvider } from "@/context/StoreContext";
import StoreLayout from "@/components/store/StoreLayout";
import AdminLayout from "@/components/admin/AdminLayout";
import Home from "@/pages/store/Home";
import Shop from "@/pages/store/Shop";
import ProductPage from "@/pages/store/ProductPage";
import CartPage from "@/pages/store/CartPage";
import Checkout from "@/pages/store/Checkout";
import OrderSuccess from "@/pages/store/OrderSuccess";
import Contact from "@/pages/store/Contact";
import Policy from "@/pages/store/Policy";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminHome from "@/pages/admin/AdminHome";
import Orders from "@/pages/admin/Orders";
import OrderDetail from "@/pages/admin/OrderDetail";
import Products from "@/pages/admin/Products";
import ProductEditor from "@/pages/admin/ProductEditor";
import Customers from "@/pages/admin/Customers";
import CustomerDetail from "@/pages/admin/CustomerDetail";
import Analytics from "@/pages/admin/Analytics";
import OnlineStore from "@/pages/admin/OnlineStore";
import Settings from "@/pages/admin/Settings";
import Payments from "@/pages/admin/Payments";
import Discounts from "@/pages/admin/Discounts";
import DiscountEditor from "@/pages/admin/DiscountEditor";
import ShippoShipping from "@/pages/admin/ShippoShipping";
import Appearance from "@/pages/admin/Appearance";
import Campaigns from "@/pages/admin/Campaigns";
import ThemeManager from "@/pages/admin/ThemeManager";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <StoreProvider>
          <CartProvider>
            <Routes>
              <Route element={<StoreLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:slug" element={<ProductPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order/success" element={<OrderSuccess />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/policies/:type" element={<Policy />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminHome />} />
                <Route path="orders" element={<Orders />} />
                <Route path="orders/:id" element={<OrderDetail />} />
                <Route path="products" element={<Products />} />
                <Route path="products/new" element={<ProductEditor />} />
                <Route path="products/:id" element={<ProductEditor />} />
                <Route path="customers" element={<Customers />} />
                <Route path="customers/:id" element={<CustomerDetail />} />
                <Route path="discounts" element={<Discounts />} />
                <Route path="discounts/new" element={<DiscountEditor />} />
                <Route path="discounts/:id" element={<DiscountEditor />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="store" element={<OnlineStore />} />
                <Route path="settings" element={<Settings />} />
                <Route path="settings/payments" element={<Payments />} />
                <Route path="settings/shipping" element={<ShippoShipping />} />
                <Route path="settings/appearance" element={<Appearance />} />
                <Route path="campaigns" element={<Campaigns />} />
                <Route path="themes" element={<ThemeManager />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-center" richColors />
          </CartProvider>
        </StoreProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
